export default "__VITE_ASSET__CLRdvjmY__"